import { render, staticRenderFns } from "./OutputTable.vue?vue&type=template&id=4a98d38d&scoped=true&"
import script from "./OutputTable.vue?vue&type=script&lang=js&"
export * from "./OutputTable.vue?vue&type=script&lang=js&"
import style0 from "./OutputTable.vue?vue&type=style&index=0&id=4a98d38d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a98d38d",
  null
  
)

export default component.exports